import React from 'react';
import { DebouncedTextField } from '../../inputs';

const NOTES_INPUT_STYLE = {
  marginBottom: 0,
  minHeight: '60px',
  resize: 'vertical',
};

export default function SystemVisibilityNotesFields({
  visibilityState,
  onPatch,
  labelStyle,
  inputStyle,
}) {
  return (
    <>
      <DebouncedTextField
        as="textarea"
        label={<span style={labelStyle}>DM Notes (private)</span>}
        style={{ ...inputStyle, ...NOTES_INPUT_STYLE }}
        value={visibilityState.dmNotes || ''}
        onCommit={(value) => onPatch({ dmNotes: value })}
        unmountPolicy="flush"
      />
      <DebouncedTextField
        as="textarea"
        label={<span style={labelStyle}>Player Notes (optional)</span>}
        style={{ ...inputStyle, ...NOTES_INPUT_STYLE }}
        value={visibilityState.playerNotes || ''}
        onCommit={(value) => onPatch({ playerNotes: value })}
        unmountPolicy="flush"
      />
    </>
  );
}
